/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import store from '@/store';
import * as api from '@/api/secret';
import { SecretSearch } from '@/api/types/secret';
import { SECRET } from '@/store/types';
import { updateObject } from '@/utils/util';
import tipModule, { StoreSecretSearchTipState } from './tip';

export interface StoreSecretSearchState {
  filter: string;
  kw: string;
  nextPoint?: number;
  result: SecretSearch[];
  limit: number;
  lock: boolean;
  noMore: boolean;
  // modules
  tip: StoreSecretSearchTipState;
}

export default {
  namespaced: true,
  modules: {
    tip: tipModule,
  },
  state: {
    filter: null,
    kw: '',
    nextPoint: null,
    result: [],
    limit: 20,
    lock: false,
    noMore: false,
  },
  getters: {},
  actions: {
    [SECRET.SEARCH_REQUEST]({ commit, state }, params) {
      if (state.filter !== params.filter || state.kw !== params.kw) {
        params.reload = true;
      }
      if ((!state.noMore && !state.lock) || params.reload) {
        if (params.kw) {
          commit(SECRET.SEARCH_REQUEST, params);
          return new Promise((resolve, reject) => {
            const point = params.reload ? null : state.nextPoint;
            Promise.all([
              api.getSearch({ filter: state.filter, kw: state.kw, point, limit: state.limit }),
              store.dispatch(`secret/${SECRET.GET_EMOTIONS}`),
              // store.dispatch(`secret/topic/list/${SECRET.GET_TOPIC_LIST}`),
            ]).then(([res]) => {
              commit(SECRET.SEARCH_SUCCESS, {
                list: res.data,
                nextPoint: res.extra && res.extra.nextPoint,
              });
              resolve();
            }).catch((err) => {
              commit(SECRET.SEARCH_FAILURE);
              reject(err);
            });
          });
        }
        commit(SECRET.SEARCH_REQUEST, params);
        commit(SECRET.SEARCH_SUCCESS, { list: [] });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [SECRET.POST_UPDATE](state: StoreSecretSearchState, { id, assign, offset }) {
      const item = state.result.find(p => p.type === 'post' && p.data.id === id);
      if (!item) {
        return;
      }
      updateObject(item.data, { assign, offset });
    },
    [SECRET.SEARCH_REQUEST](state: StoreSecretSearchState, { filter, kw, reload }) {
      if (reload) {
        state.filter = filter;
        state.kw = kw;
        state.nextPoint = void 0;
        state.noMore = false;
        state.result = [];
      }
      state.lock = true;
    },
    [SECRET.SEARCH_SUCCESS](state: StoreSecretSearchState, { list, nextPoint }) {
      state.nextPoint = nextPoint;
      state.noMore = !nextPoint;
      state.result = state.result.concat(list);
      state.lock = false;
    },
    [SECRET.SEARCH_FAILURE](state: StoreSecretSearchState) {
      state.lock = false;
    },
  },
};
